import { render, staticRenderFns } from "./StreamTailorBatchItems.vue?vue&type=template&id=2659b2fa&"
import script from "./StreamTailorBatchItems.vue?vue&type=script&lang=ts&"
export * from "./StreamTailorBatchItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports